import { GetterTree } from 'vuex'
import { WhiteListsState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<WhiteListsState, RootState> = {
    whiteLists:state => state.whiteLists
};
